import LogEntries             from 'scripts/defa/log/collection-log-entries';
import LogEntry               from 'scripts/defa/log/model-log-entry';
import LogContainer           from 'scripts/defa/log/view-log-container';
import LogEntryCollectionView from 'scripts/defa/log/view-log-entry-collection-view';
import LogEntryCreateForm     from 'scripts/defa/log/view-log-entry-create-form';
import LogEntryView           from 'scripts/defa/log/view-log-entry-view';
import LogTagsForm            from 'scripts/defa/log/view-log-tags-form';
import Module                 from 'scripts/module';

const LogModule = new Module( 'LogModule', {
	collections: {
		LogEntries
	},
	models     : {
		LogEntry
	},
	views      : {
		LogContainer,
		LogEntryCollectionView,
		LogEntryCreateForm,
		LogEntryView,
		LogTagsForm
	}
} );
export default LogModule;